import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function EditProfileCustomFields() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-839" data-mp="cddvs2f2n987">
      <div className="flex items-center justify-between" data-id="element-840" data-mp="hbp428ppxbob">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-841" data-mp="hb5pn1za15f1">
          Edit My Profile Custom Fields:
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-842" data-mp="3fvfa8uf1ni7c">
          ← Back to Admin Area
        </Button>
      </div>
      <Card data-id="element-843" data-mp="3tuevrt79fgza">
        <CardContent className="pt-6" data-id="element-844" data-mp="3tqr4z1t798o9">
          <form className="space-y-4 max-w-md" data-id="element-845" data-mp="152199btkwub7">
            <div className="flex items-center gap-3" data-id="element-846" data-mp="153ccnaj4401s">
              <label className="text-sm font-medium text-slate-700 w-24" data-id="element-847" data-mp="191tmw2xtxqnf">
                Select Field
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-20" data-id="element-848" data-mp="17s5eieyq0u85">
                <option data-id="element-849" data-mp="xu7sly4c39ip">1</option>
                <option data-id="element-850" data-mp="xt6bpd0mzst2">2</option>
                <option data-id="element-851" data-mp="xwkdaj1h7xzg">3</option>
              </select>
            </div>
            <div className="flex items-center gap-4" data-id="element-852" data-mp="tscoymyxkk1r">
              <label className="text-sm font-medium text-slate-700 w-24" data-id="element-853" data-mp="otjdt174954r">
                Select Field Type
              </label>
              <div className="flex items-center gap-4" data-id="element-854" data-mp="k2b0hu2o0zmb">
                <label className="flex items-center gap-1.5 cursor-pointer" data-id="element-855" data-mp="f3ztrs7o358b">
                  <input type="radio" name="fieldType" value="text" defaultChecked className="focus:ring-slate-400" data-id="element-856" data-mp="f1x4xbi93i56" />
                  <span className="text-sm text-slate-700" data-id="element-857" data-mp="13p06hez3cjg">Text Field</span>
                </label>
                <label className="flex items-center gap-1.5 cursor-pointer" data-id="element-858" data-mp="3nlh753aqxoe0">
                  <input type="radio" name="fieldType" value="dropdown" className="focus:ring-slate-400" data-id="element-859" data-mp="3rnlytwhmway0" />
                  <span className="text-sm text-slate-700" data-id="element-860" data-mp="3imw3sv076olc">Drop Down</span>
                </label>
              </div>
            </div>
            <div data-id="element-861" data-mp="a85hoy2edxoy">
              <input type="text" defaultValue="are you on facebook?" className="h-8 w-full max-w-xs rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-862" data-mp="a7m7y4mwifm0" />
            </div>
            <div className="flex items-center gap-2" data-id="element-863" data-mp="5f2ur8s4lmhq">
              <input type="checkbox" id="required" className="rounded border-slate-300 focus:ring-slate-400" data-id="element-864" data-mp="t68bdq5w4it3" />
              <label htmlFor="required" className="text-sm text-slate-700" data-id="element-865" data-mp="xyrq4qgbdjzh">
                Required
              </label>
            </div>
            <div className="pt-2" data-id="element-866" data-mp="2doivpm34gewd">
              <Button type="submit" data-id="element-867" data-mp="2dnhh57mwda9w">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}